module.exports = __webpack_public_path__ + "media/img/pages/companies/groupemutuel-vertical-c70a2e621e56a03db3c6ccd3ca48e97e.png";